import React, { useState } from 'react';
import styled from 'styled-components';
import DonateDialogue from '../popup/donate';

const Footer = () => {
  const [isPopupVisible, setPopupVisibility] = useState(false);

  const openPopup = () => setPopupVisibility(true);
  const closePopup = () => setPopupVisibility(false);

  return (
    <>
      <FooterBody>
        <FooterText>Made with ❤️ in KGP for KGP</FooterText>
        <SupportButton onClick={openPopup}>Support Us</SupportButton>
      </FooterBody>
      {isPopupVisible && <DonateDialogue onClose={closePopup} />}
    </>
  );
};

const FooterBody = styled.div`
  height: 8vh;
  background: #6559a2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: relative;

  @media only screen and (max-width: 600px) {
    height: auto;
    margin-top: 20px;
    padding: 5px 0;
    display: none;
  }
`;

const FooterText = styled.p`
  background: #6559a2;
  color: white;
  margin: 0px 0px;
  margin-bottom: 5px;
`;

const SupportButton = styled.button`
  // margin-top: 5px;
  padding: 5px 10px;
  border-radius: 5px;
  background: #3cb043;
  color: white;
  border: none;
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.2) -3px 3px 0px;
`;

export default Footer;